import type { ScreeningJob } from "./types";

interface StatusBadgeProps {
  job: ScreeningJob;
}

export function StatusBadge({ job }: StatusBadgeProps) {
  const map: Record<ScreeningJob["status"], string> = {
    extracting: "bg-surface-secondary text-text-focused",
    ocr: "bg-amber-100 text-amber-800",
    screening: "bg-rausch-light text-rausch",
    done: "bg-emerald-100 text-emerald-800",
    error: "bg-rose-100 text-error-text",
    duplicate: "bg-amber-100 text-amber-800",
  };
  const label: Record<ScreeningJob["status"], string> = {
    extracting: job.statusDetail || "Extracting text...",
    ocr: job.statusDetail || "Running OCR...",
    screening: "AI Screening...",
    done: "Done",
    error: `Error: ${job.error ?? ""}`,
    duplicate: "Duplicate",
  };
  const isProcessing = job.status !== "done" && job.status !== "error" && job.status !== "duplicate";

  return (
    <span
      className={`ml-2 inline-flex items-center gap-1.5 max-w-[60%] truncate rounded-badge px-2.5 py-0.5 text-xs font-medium ${map[job.status]}`}
      title={label[job.status]}
    >
      {isProcessing && (
        <svg className="h-3 w-3 animate-spin" viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      )}
      {label[job.status]}
    </span>
  );
}
